// This file is generated by bin/generate-theme.ts

// FontWeights design tokens
export const fontWeights = {
  default: 'W4',
  bold: 'W6',
};

export type FontWeightsTokens = typeof fontWeights;
export type FontWeightsKey = keyof FontWeightsTokens;
